import React from 'react'
import { observer } from 'mobx-react'
import { Dropdown, DropdownItem, DropdownTitle } from 'components/Dropdown'
import Icon from 'components/Icon'
import { FilterItem } from 'infra/FiltersViewModel'
import { useActivation } from 'hooks/mobx-hooks'
import { SingleSelectFilter } from '../../../../infra/FilterControls/SingleSelect/SingleSelectFilter'
import { InventoryItemTypeFilter } from 'admin/inventory/InventorySearchViewModel'
import styles from './InventoryViewer.sass'

interface InventoryViewerProps<TFilters extends Record<string, unknown>> {
  filter: SingleSelectFilter<keyof TFilters, InventoryItemTypeFilter>
}

export default observer(function InventoryViewer<
  TFilters extends Record<string, unknown>,
>({ filter }: InventoryViewerProps<TFilters>) {
  useActivation(filter)

  return (
    <Dropdown
      autoDismiss
      position="bottom-start"
      button={
        <a className={styles.root}>
          {filter.title} {filter.value?.title}
          <Icon auto name="dropdown" />
        </a>
      }
      dataTest="inventory-viewer-dropdown"
    >
      <DropdownTitle>View</DropdownTitle>
      {filter.options
        .filter((opt) => opt.value.visible)
        .map((option, index) => (
          <FilterOptionItem
            key={`${option.title}-${index}`}
            option={option}
            filter={filter}
          />
        ))}
    </Dropdown>
  )
})

interface FilterOptionItemProps<TFilters> {
  option: FilterItem<InventoryItemTypeFilter>
  filter: SingleSelectFilter<keyof TFilters, InventoryItemTypeFilter>
}

const FilterOptionItem = observer(function <
  TFilters extends Record<string, unknown>,
>({ option, filter }: FilterOptionItemProps<TFilters>) {
  const isActive = filter.isSelected(option.value)
  return (
    <DropdownItem
      onClick={() => filter.change(option.value)}
      checkmark={isActive}
      active={isActive}
      dataTest={`inventory-item-type-filter-${option.value.title}`}
    >
      <div className={styles.filterText}>{option.title} </div>
    </DropdownItem>
  )
})
